<template>
  <div class="compare-wrap m-t-20">
    <div class="flex-align__between">
      <div class="compare-tips flex-align__between">
        <div class="compare-tips__item lowest flex-align">最低价</div>
        <div class="compare-tips__item highest flex-align">最高价</div>
      </div>

      <el-button
        v-if="needGrand"
        type="primary"
        class="flex-center"
        @click="handleSelectLowest"
      >一键选择最低报价</el-button>

      <el-button
        v-else
        type="primary"
        class="flex-center"
        @click="exportCompareInfo"
      >导出比价单结果</el-button>
    </div>

    <el-table
      ref="table"
      border
      :data="pageTableData"
      :span-method="objectSpanMethod"
      class="compare-table"
    >
      <el-table-column align="center" label="品目信息" fixed="left" width="580">
        <el-table-column
          align="center"
          label="序号"
          prop="index"
          type="index"
          :index="indexMethod"
          width="50"
        />
        <el-table-column align="center" label="品目信息" width="350">
          <template slot-scope="{ row }">
            <div class="table-item">
              <div class="column">
                <div class="column-item">
                  <div class="column-item__title">品目名称</div>
                  <div class="column-item__content">
                    {{ row.itemName || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">品目编码</div>
                  <div class="column-item__content">
                    {{ row.itemCode || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">数量</div>
                  <div class="column-item__content">
                    {{ row.itemNum ? strToThousands(row.itemNum) : ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">参数型号</div>
                  <div class="column-item__content">
                    {{ row.itemModel || ' - ' }}
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-item">
                  <div class="column-item__title">品牌/制造商</div>
                  <div class="column-item__content">
                    {{ row.itemBrand || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">交货地点</div>
                  <div class="column-item__content">
                    {{ row.deliveryAddress || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">交货时间</div>
                  <div class="column-item__content">
                    {{ row.deliveryDay || ' - ' }} 天
                  </div>
                </div>
                <div v-if="showAward" class="column-item">
                  <div class="column-item__title">授标量</div>
                  <div
                    class="column-item__content"
                    :class="{
                      'text-warning':
                        parseFloat(getAwardNum(row)) > parseFloat(row.itemNum)
                    }"
                  >
                    {{ strToThousands(getAwardNum(row)) }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格" width="180">
          <template slot-scope="{ row }">
            <div class="table-item">
              <div class="column">
                <div class="column-item">
                  <div class="column-item__title">预算单价</div>
                  <div class="column-item__content">
                    {{ row.unitPrice ? strToThousands(row.unitPrice) : '-' }}
                    元
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">总价</div>
                  <div class="column-item__content">
                    {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
                    元
                    <money-in-cn
                      :money="row.totalPrice"
                      :ellipsis="false"
                      width="100px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="报价信息"
        align="center"
        width="100px"
        fixed="left"
      >
        <template slot-scope="{ row }">
          <div v-if="row.offerName === '议价'">
            <el-checkbox
              v-model="row.isBargain"
              @change="changeBargain(row)"
            >议价</el-checkbox>
          </div>
          <span
            v-else
            :class="{ 'text-primary': row.offerName === '选择授标数量' }"
          >
            {{ row.offerName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="报价供应商" align="center">
        <el-table-column
          v-for="item in headerList"
          :key="item.supplierName"
          :label="`${item.supplierName}`"
          align="center"
          min-width="200"
        >
          <template slot="header">
            <div>{{ item.supplierName }}</div>
            <div class="flex-content">
              <div style="white-space: nowrap">报价总金额：</div>
              <div class="flex flex-column col-top">
                {{
                  item.offerTotalPrice
                    ? strToThousands(item.offerTotalPrice)
                    : 0
                }}
                元
              </div>
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <div
              v-if="row.offerName === '选择授标数量'"
              class="flex-align__end"
            >
              <el-checkbox
                v-model="row.offerValue[item.supplierId].check"
                style="margin-right: 0.5rem;"
                :disabled="!row.offerValue[item.supplierId].detailId"
                @change="checkChange(row, item, $index)"
              />
              <el-input-number
                v-model.number="row.offerValue[item.supplierId].awardNum"
                placement="请输入数量"
                :disabled="!row.offerValue[item.supplierId].check"
                size="mini"
                :min="0"
                :precision="2"
                :controls="false"
                @blur="checkNumber(row)"
              />
            </div>
            <div v-else-if="row.offerName === '议价'" class="flex-align__end">
              <el-input-number
                v-model.number="row.offerValue[item.supplierId].bargainAmount"
                placement="请输入"
                :disabled="
                  !isNumChecked($index, item.supplierId) || !row.isBargain
                "
                size="mini"
                :min="0"
                :precision="2"
                :controls="false"
                @blur="checkNumber(row)"
              />
              <span class="m-l-10">元</span>
            </div>
            <div
              v-else
              :class="getTextColor(row, item)"
              :style="{
                'text-align': alignRight(row, item) ? 'right' : 'center'
              }"
            >
              {{ getRowValue(row, item) }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <pagination
      v-show="tableData.length > size"
      :total="tableData.length / spanNum"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
// 组件
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'CompareSheet',

  components: {
    Pagination,
    MoneyInCn
  },

  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    headerList: {
      type: Array,
      default: () => []
    },

    // 需要授标操作
    needGrand: {
      type: Boolean,
      default: false
    },

    // 需要跨越的行
    spanNum: {
      type: Number,
      default: 3
    },

    // 是否展示授标量
    showAward: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 前端模拟分页
      page: 1,
      size: 20,
      pageTableData: []
    }
  },

  computed: {
    indexMethod() {
      return index => {
        return Math.round(index / this.spanNum + 1)
      }
    },

    sizeMultiple() {
      return this.size * this.spanNum
    }
  },

  watch: {
    page() {
      this.getPageData()
    },
    size() {
      this.getPageData()
    },

    tableData: {
      handler: function(val) {
        this.page = 1
        this.getPageData()
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,

    isNumChecked(index, supplierId) {
      return !!this.tableData[index + 1].offerValue[supplierId].check
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const tempIndexArray = [0, 1, 2]
      if (this.inMultiple) tempIndexArray.push(3)
      if (tempIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex % this.spanNum === 0) {
          return {
            rowspan: this.spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    // 一键选择最低价
    handleSelectLowest() {
      const tempArr = this.tableData.filter((v, i) => {
        if ((i + 1) % this.spanNum === 0) {
          return v
        }
      })
      if (JSON.stringify(tempArr[0].offerValue) === '{}') {
        this.$message.warning('无最低报价')
        return false
      }

      let tempBool = true
      tempArr.forEach(v => {
        const tempPrice = v.offerValue

        tempBool = Object.keys(tempPrice).some(key => {
          if (tempPrice[key].low) {
            tempPrice[key].check = true
            tempPrice[key].awardNum = Number(v.itemNum) || undefined
            return true
          }
        })
      })
      if (!tempBool) {
        this.$message.error('存在品目无法选择最低报价，请手动选择')
        return false
      }
    },

    // 获取单个品目的授标总量
    getAwardNum(row) {
      let awardNum = 0
      this.tableData.forEach((v, index) => {
        if ((index + 1) % this.spanNum === 0 && v.itemId === row.itemId) {
          const tempOffer = v.offerValue
          Object.keys(tempOffer).find(key => {
            if (tempOffer[key].check) {
              awardNum =
                (awardNum * 100 + (tempOffer[key].awardNum || 0) * 100) / 100
            }
          })
        }
      })

      return awardNum.toFixed(2)
    },

    // 导出比价结果
    exportCompareInfo() {
      this.$emit('export')
    },

    // 比较数值
    checkNumber(row) {
      let totalNum = 0
      Object.keys(row.offerValue).find(key => {
        if (row.offerValue[key].check) {
          totalNum =
            (totalNum * 100 + (row.offerValue[key].awardNum || 0) * 100) / 100
        }
      })
      if (totalNum > Number(row.itemNum)) {
        this.$alert('已超出采购量, 是否继续采购', '系统提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    },

    /**
     * 当选择授标数量改变的时候
     */
    checkChange(row, item, index) {
      const tempItem = row.offerValue[item.supplierId]
      if (tempItem.check) {
        tempItem.awardNum = Number(row.awardNum) || 0
      } else {
        tempItem.awardNum = undefined
      }
      this.checkNumber(row)
      this.pageTableData[index - 1].offerValue[
        item.supplierId
      ].bargainAmount = undefined
    },

    /**
     * 当改变议价按钮
     */
    changeBargain(row) {
      Object.values(row.offerValue || {}).forEach(el => {
        el.bargainAmount = undefined
      })
    },

    getTextColor(row, item) {
      const info = row.offerValue[item.supplierId]
      const offerName = row.offerName
      if (info.high) return 'text-danger'

      if (info.low) return 'text-success'

      if (offerName === '品牌/制作商' && info.value !== row.materielBrand) {
        return 'text-danger text-bold'
      }

      return ''
    },

    /**
     * 前端模拟分页：获取分页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.sizeMultiple
      const end = start + this.sizeMultiple
      this.pageTableData = this.tableData.slice(start, end).map(el => {
        if (el.offerName === '议价') {
          const offerValueList = Object.values(el.offerValue) || []
          this.$set(
            el,
            'isBargain',
            offerValueList.some(k => !!k.bargainAmount)
          )
        } else if (el.offerName === '选择授标数量') {
          Object.keys(el.offerValue).forEach(m => {
            this.$set(el.offerValue[m], 'check', !!el.offerValue[m].awardNum)
          })
        }
        return el
      })
    },

    /**
     * 获取当前行的展示内容
     */
    getRowValue(row, item) {
      const value = row.offerValue[item.supplierId].value || '-'
      return value.includes('元') ? strToThousands(value) : value
    },

    /**
     * 当前行展示的内容是否需要右对齐
     */
    alignRight(row, item) {
      const needAlignRightArray = ['未含税价', '含税价', '总价']
      return needAlignRightArray.includes(row.offerName)
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-wrap {
  margin: 20px 0;

  .compare-tips {
    .compare-tips__item {
      &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 2px;
        margin-right: 8px;
      }

      &.lowest::before {
        background-color: $success-color;
      }

      &.highest::before {
        background-color: $danger-color;
      }

      & + .compare-tips__item {
        margin-left: 40px;
      }
    }
  }

  .compare-table {
    margin-top: 20px;
  }
}

.multiple-tips {
  font-size: pixel-to-rem($n: 20);
  color: $third-text-color;

  &::before {
    content: '*';
    color: $danger-color;
    padding-right: pixel-to-rem($n: 4);
  }

  .multiple-tips__important {
    color: $text-color;
    display: inline-block;
    margin-right: pixel-to-rem($n: 20);
  }
}

.table-item {
  .column {
    flex: 1;

    .column-item {
      display: flex;
      align-items: flex-start;

      .column-item__title {
        @include text-bold;
        white-space: nowrap;
        width: 76px;
        text-align: right;

        &::after {
          content: '：';
          display: inline-block;
        }
      }

      .column-item__content {
        flex: 1;
        margin: 0;
        text-align: left;
      }
    }
  }
}

::v-deep {
  .el-table th {
    border-top: none;
  }
}
</style>
